'use client';

import { Dispatch, SetStateAction } from 'react';
import {
  ibow2_proto_RequestUser,
  ibow2_proto_RequestUserFavorite,
} from '@/init/swagger';
import { swaggerClient } from '@/init/swaggerClient';
import { apiRequest } from '@/helpers/apiRequestHelper';
import { useSnackbar } from '@/hooks/useSnackbar';

type LogicProps = {
  requestUser: ibow2_proto_RequestUser;
  favorites: ibow2_proto_RequestUserFavorite[];
  setFavorites: Dispatch<SetStateAction<ibow2_proto_RequestUserFavorite[]>>;
  portalOfficeId: number;
};

export const useLogic = ({
  requestUser,
  favorites,
  setFavorites,
  portalOfficeId,
}: LogicProps) => {
  const { openSnackbar } = useSnackbar();

  const isFavorited = (): boolean => {
    return favorites.some((f) => f.portal_office_id === portalOfficeId);
  };

  const handleToggleFavorite = (
    event: React.MouseEvent<HTMLButtonElement>,
  ): void => {
    event.preventDefault();
    event.stopPropagation();

    const favorite = favorites.find(
      (f) => f.portal_office_id === portalOfficeId,
    );

    if (favorite) {
      apiRequest({
        requestFunc: () =>
          swaggerClient.requestUserFavorite.postRequestUserFavoritesDelete({
            body: {
              favorite_id: Number(favorite.id),
            },
          }),
        resolveFunc: () => {
          const newFavorites = favorites.filter((f) => f.id !== favorite.id);
          setFavorites(newFavorites);
          openSnackbar('お気に入りを解除しました', 'info');
        },
        rejectFunc: () => {
          openSnackbar('お気に入りの解除に失敗しました', 'error');
        },
      });
    } else {
      apiRequest({
        requestFunc: () =>
          swaggerClient.requestUserFavorite.postRequestUserFavoritesSave({
            body: {
              request_user_id: Number(requestUser.id),
              portal_office_id: portalOfficeId,
            },
          }),
        resolveFunc: (res) => {
          const newFavorites = favorites.concat(
            res.request_user_favorite as ibow2_proto_RequestUserFavorite,
          );
          setFavorites(newFavorites);
          openSnackbar('お気に入りに登録しました', 'info');
        },
        rejectFunc: () => {
          openSnackbar('お気に入りの登録に失敗しました', 'error');
        },
      });
    }
  };

  return { isFavorited, handleToggleFavorite };
};
